import React from 'react';
import { Helmet } from 'react-helmet-async';
import { DEFAULT_SEO } from 'config/seo';

interface PageMetaProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
}

const PageMeta: React.FC<PageMetaProps> = ({ title, description, image, url }) => {
  const pageTitle = title ? `${title} | ${DEFAULT_SEO.title}` : DEFAULT_SEO.title;
  const pageDescription = description ?? DEFAULT_SEO.description;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:type" content={DEFAULT_SEO.ogType} />
      {image && <meta property="og:image" content={image} />}
      {url && <meta property="og:url" content={url} />}
      <meta name="twitter:card" content={DEFAULT_SEO.twitterCard} />
    </Helmet>
  );
};

export default PageMeta;
